let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10,
  _t11,
  _t12,
  _t13,
  _t14;
import styled from 'styled-components';
import { Card, DropdownBase, Text } from '@ovpn-ui/core';
import { colors, fontSize, fontWeights } from '@ovpn-ui/styles';
import { sidebarWidth } from '../Sidebar.constants';
export const StyledTenantSwitcher = styled(DropdownBase)(_t || (_t = _`
    padding: 0;

    border: none;
    transform: unset;
`));
export const IconContainer = styled.div(_t2 || (_t2 = _`
    position: relative;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    width: 24px;
    height: 24px;
`));
export const Container = styled(Card)(_t3 || (_t3 = _`
    position: relative;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: ${0};
    max-width: 100%;
    height: ${0};
    margin: ${0};
    margin-top: ${0};
    padding: 8px;

    color: ${0};

    background: ${0};
    border: 1px solid ${0};
    border-radius: ${0};
    box-shadow: none;
    cursor: pointer;

    &:hover {
        background-color: ${0};
    }

    svg {
        width: unset;
        height: unset;

        color: ${0};
    }
`), props => props.collapsed ? '40px' : 'auto', props => {
  if ((props.collapsed || props.tablet) && !props.mobile) {
    return '40px';
  }
  return '64px';
}, props => {
  if (props.collapsed) {
    return '12px 11.5px';
  }
  return '0 11.5px';
}, props => props.mobile ? '24px' : '0', t => t.theme.text, props => {
  if ((props.collapsed || props.tablet) && !props.mobile) {
    return `linear-gradient(to bottom right, transparent 49.8%, ${props.theme.text} 50%) bottom right/8px 8px no-repeat, ${props.theme.bg}`;
  }
  return props.theme.bg;
}, t => t.theme.border, props => {
  if ((props.collapsed || props.tablet) && !props.mobile) {
    return '8px 8px 0px 8px';
  }
  return '8px';
}, t => t.theme.itemActiveColor, t => t.theme.text);
export const CurrentTenant = styled.div(_t4 || (_t4 = _`
    position: absolute;
    left: 44px;

    display: flex;
    flex-direction: column;

    max-width: 162px;
`));
export const NoWrap = styled(Text)(_t5 || (_t5 = _`
    inline-size: ${0};

    overflow: hidden;

    white-space: nowrap;

    text-overflow: ellipsis;
`), props => props.mobile ? `${sidebarWidth}px` : '179px');
export const TenantHeader = styled.div(_t6 || (_t6 = _`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 72px;
    padding: 8px 0px 16px 4px;
`));
export const TenantTitle = styled(Text)(_t7 || (_t7 = _`
    font-weight: ${0};
    font-size: ${0};
`), fontWeights.semiBold, fontSize.default);
export const SearchContainer = styled.div(_t8 || (_t8 = _`
    margin: -6px 0 24px 0;
`));
export const TenantMenu = styled.div(_t9 || (_t9 = _`
    position: relative;

    width: ${0};
    height: 100vh;

    padding: 8px 12px;

    background-color: ${0};
    border-right: 1px solid ${0};
    border-radius: 0px;
`), props => props.mobile ? '100%' : `${sidebarWidth}px`, colors.neutralOffwhite, t => t.theme.border);
export const TenantList = styled.div(_t10 || (_t10 = _`
    display: flex;
    flex-direction: column;
    gap: 8px;
    height: 100%;
    margin-right: -12px;
    padding-bottom: ${0}px;
    overflow-y: auto;
`), props => props.mobile ? '282' : '240');
export const StyledOption = styled.a(_t11 || (_t11 = _`
    display: flex;
    align-items: center;
    justify-content: space-between;

    min-height: 40px;
    max-height: 40px;

    margin-right: 12px;
    padding: 8px 8px;

    color: ${0};

    text-decoration: none;

    background-color: ${0};

    border-radius: 8px;

    cursor: pointer;

    &:hover {
        background-color: ${0};
    }

    svg {
        flex-shrink: 0;
    }
`), colors.neutralTextBody, props => props.active ? colors.neutralBgHover : colors.neutralOffwhite, colors.neutralBgHover);
export const LabelContainer = styled.div(_t12 || (_t12 = _`
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: flex-start;
`));
export const TenantLabel = styled(Text)(_t13 || (_t13 = _`
    inline-size: ${0};

    overflow: hidden;

    font-weight: ${0};
    font-size: ${0};
    white-space: nowrap;
    text-overflow: ellipsis;
`), props => props.mobile ? `${sidebarWidth}px` : '179px', fontWeights.medium, fontSize.default);
export const TenantFooter = styled.div(_t14 || (_t14 = _`
    position: absolute;
    bottom: 0;
    left: 0;

    display: flex;

    flex-grow: 0;
    flex-shrink: 0;

    align-items: center;

    width: 100%;
    margin-bottom: ${0}px;
    padding: 24px 15px 24px 14px;

    background-color: ${0};

    &::before {
        position: absolute;
        top: 0;
        left: 5%;

        display: block;
        width: 90%;
        height: 1px;

        background: ${0};

        content: ' ';
    }
`), props => props.mobile ? '56' : '0', colors.neutralOffwhite, colors.neutralLight);